angular
    .module('MyApp')
    .service('AcervoService', ['$resource', '$q', 'Configs','$ionicLoading','DownloadArquivo', function($resource, $q, Configs, $ionicLoading,DownloadArquivo) {
      
        var _msgErro = { msgErro: 'Error student undefined' };

      this.obterDocumetosAcervoGeral = function(codAluno) {
        let defer = $q.defer();
        if (codAluno) {
            $resource(Configs.getApiServer() + '/pessoas/documentos-acervo-geral?idAluno='+codAluno, {}, {
                cache: false,
                query: {
                    method: 'GET',
                }
            })
            .query(function(result) {
                defer.resolve(result);
            }, function(err) {
                defer.reject(err);
            });
        } else {
            defer.reject({ _msgErro });
        }
        return defer.promise;
      }

      this.obterArquivoAcervoGeral = function(idArquivo) {
        $ionicLoading.show({
            content : 'Loading',
            animation : 'fade-in',
            showBackdrop : true,
            maxWidth : 200,
            showDelay : 1
        });

        let params = {};
			params.url = Configs.getApiServer() + '/pessoas/obter-arquivo-acervo-geral?idArquivo='+idArquivo; 
			params.method = "GET";
				
		DownloadArquivo.downloadArquivo(params);
      }
      
    }]);